import { Component, ViewChild, OnInit } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { FormBuilder } from '@angular/forms';
import { SiteSummary } from 'app/_models/site-summary.model';
import { NotificationService } from 'app/_services/notification.service';
import { DynamicFormComponent } from 'app/_dynamic_form/containers/dynamic_form/dynamic-form.component';
import { environment } from 'environments/environment';
import { SessionsService } from 'app/_services/sessions.service';
import { ContractorService } from 'app/_services/contractor.service';
import { SiteService } from 'app/_services/site.service';

import { ngxCsv } from 'ngx-csv/ngx-csv';
import { range } from 'rxjs';
import { map, mergeMap, switchMap, tap, toArray } from 'rxjs/operators';

@Component({
  selector: 'app-site-sessions',
  templateUrl: './site-sessions.component.html',
})
export class SiteSessionsComponent implements OnInit {
  @ViewChild(DynamicFormComponent) filterForm: DynamicFormComponent;

  users: any[] = [];
  selectedUser: any;

  sidebarVisible = false;

  pageSizes: any = environment.pageSizes;
  pagination: any;
  @ViewChild('paginator', { static: true }) paginator;

  selectedSort: any;

  sortFields: any[] = [
    {
      sortName: 'First Name (asc)',
      sortString: 'user.firstName,asc',
    },
    {
      sortName: 'First Name (desc)',
      sortString: 'user.firstName,desc',
    },
    {
      sortName: 'Last Name (asc)',
      sortString: 'user.lastName,asc',
    },
    {
      sortName: 'Last Name (desc)',
      sortString: 'user.lastName,desc',
    },
  ];

  role: any;
  routeRole: any;

  errorAlerts: any[] = [];

  sitesArray: any[] = [];
  companiesArray: any[] = [];
  siteSessions: any[] = [];
  toDate;
  fromDate;
  maxDate;
  value: Date;
  selectedSite: any;
  selectedCompany: any;
  private isSiteOwnerView: any;
  private readonly exportPageSize = 200;
  private readonly exportConcurrency = 4;

  // Export Options
  options = {
    title: '',
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalseparator: '.',
    showLabels: true,
    showTitle: false,
    useBom: true, // Excel-friendly UTF-8
    noDownload: false,
    // tslint:disable-next-line:max-line-length
    headers: ['ID', 'Site Name', 'Companies', 'Created By', 'Start Time', 'End Time', 'Work Order ID', 'Work Order Description', 'Asset'],
  };

  constructor(
    public loader: LoadingBarService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public globals: Globals,
    public fb: FormBuilder,
    public notificationService: NotificationService,
    public sessionsService: SessionsService,
    public contractorService: ContractorService,
    public sitesService: SiteService
  ) {
    this.role = globals.user.role;
    this.routeRole = globals.user.routeRole;
    this.isSiteOwnerView = this.routeRole === 'site-owner';

    this.selectedSort = this.sortFields[0];
    this.selectedCompany = { label: 'Select Company', value: undefined };
    this.selectedSite = { label: 'Select Site', value: undefined };
    this.toDate = new Date();
    const tempFromDate = new Date().setDate(this.toDate.getDate() - 30);
    this.fromDate = new Date(tempFromDate);
    this.maxDate = this.toDate;
  }

  ngOnInit() {
    this.resetPagination();
    this.getAllSiteSessions(this.pagination, 'startTime', 'asc', this.fromDate, this.toDate, this.selectedSite.value, this.selectedCompany.value);
    this.getAllSites();
    this.getAllContractors();
  }

  // Get all site sessions, accepting startdate, enddate, site and company
  public getAllSiteSessions(pagination, sortProperty, sortDirection, from, to, site?, company?) {
    const fromTimestamp = from.getTime();
    const toTimestamp = to.getTime();
    this.sessionsService.getAllSiteSessions(pagination, sortProperty, sortDirection, fromTimestamp, toTimestamp, site, company).subscribe((data: any) => {
      this.siteSessions = [];
      data.body.forEach((element) => {
        this.siteSessions.push(element);
      });

      this.pagination.totalRecords = Number(data.headers.get('X-Total-Count'));
    });
  }

  public getAllSites() {
    this.sitesService.getSiteListSummary().subscribe((data: SiteSummary[]) => {
      this.sitesArray.push(this.selectedSite);
      data.forEach((element: SiteSummary) => {
        const item = {
          label: element.siteName,
          value: element.siteId,
        };
        this.sitesArray.push(item);
      });
    });
  }

  public getAllContractors() {

    if (this.isSiteOwnerView) {
      let siteOwnerId = this.globals.siteOwnerUsers[0].skylarkUserId;
      this.contractorService.getLinkedContractors(siteOwnerId, ({ size: 999, page: 0 }), 'name,asc', undefined).subscribe(
        (data: any) => {
          this.companiesArray = [
            { label: 'Select a company', value: null },
            ...data.body.map((element) => ({
              label: element.name,
              value: JSON.stringify(element.id),
            }))];
        },
        (error) => {
          console.error(error);
          this.notificationService.notify('danger', 'Error retrieving contractor list');
        });
    } else {
      this.contractorService.getAllContractorFullList().subscribe((data: any) => {
        this.companiesArray.push(this.selectedCompany);
        data.forEach((element) => {
          const item = {
            label: element.name,
            value: JSON.stringify(element.id),
          };
          this.companiesArray.push(item);
        });
      });
    }
  }

  /* PAGINATION */
  public resetPagination() {
    this.pagination = {
      size: this.pageSizes[0],
      page: 0,
      totalRecords: 0,
    };
    this.goToFirstPage();
  }

  public paginate(event) {
    this.pagination.size = event.rows;
    this.pagination.page = event.page;
    this.getAllSiteSessions(this.pagination, 'startTime', 'asc', this.fromDate, this.toDate, this.selectedSite.value, this.selectedCompany.value);
  }

  private goToFirstPage() {
    this.pagination.page = 0;      // Backend: reset page index to fetch from API
    if (this.paginator) {
      this.paginator.first = 0;    // Frontend: update visual page indicator (PrimeNg)
    }
  }
  /* PAGINATION END */

  // Handle Changes and relevant calls
  public onFromDateChange(event) {
    if (!event) { return; }

    this.fromDate = event;
    this.goToFirstPage();
    // tslint:disable-next-line:max-line-length
    this.getAllSiteSessions(this.pagination, 'startTime', 'asc', event, this.toDate, this.selectedSite.value, this.selectedCompany.value);
  }

  public onToDateChange(event) {
    if (!event) { return; }

    this.toDate = event;
    this.goToFirstPage();
    // tslint:disable-next-line:max-line-length
    this.getAllSiteSessions(this.pagination, 'startTime', 'asc', this.fromDate, event, this.selectedSite.value, this.selectedCompany.value);
  }

  public onSelectedSiteChange(event) {
    // tslint:disable-next-line:max-line-length
    this.selectedSite = event;
    this.goToFirstPage();
    this.getAllSiteSessions(this.pagination, 'startTime', 'asc', this.fromDate, this.toDate, event.value, this.selectedCompany.value);
  }

  public onSelectedCompanyChange(event) {
    this.selectedCompany = event;

    this.goToFirstPage();
    // tslint:disable-next-line:max-line-length
    this.getAllSiteSessions(this.pagination, 'startTime', 'asc', this.fromDate, this.toDate, this.selectedSite.value, event.value);
  }

  public export() {
    const fromTimestamp = this.fromDate.getTime();
    const toTimestamp = this.toDate.getTime();
    // tslint:disable-next-line:max-line-length
    const getPage = (page: number, size: number) => this.sessionsService.getAllSiteSessions({ size: size, page: page }, 'startTime', 'asc', fromTimestamp, toTimestamp, this.selectedSite.value, this.selectedCompany.value);

    // The backend caps a page at 4,000 rows, so the export reads the total first and then fetches every page.
    getPage(0, 1).pipe(
      switchMap((probe: any) => {
        const totalPages = Math.ceil(Number(probe.headers.get('X-Total-Count')) / this.exportPageSize);
        const siteSessionsByPage: any[][] = new Array(totalPages);
        return range(0, totalPages).pipe(
          mergeMap(page => getPage(page, this.exportPageSize).pipe(
            tap((data: any) => siteSessionsByPage[page] = data.body)
          ), this.exportConcurrency),
          toArray(),
          map(() => siteSessionsByPage.reduce((acc, pageRows) => acc.concat(pageRows), []))
        );
      })
    ).subscribe((siteSessions: any[]) => {
      this.exportData(siteSessions);
    });
  }

  public exportData(selectedSessions) {
    const sessionsToExport = [];
    selectedSessions.forEach((element) => {
      const sessionObj = {
        id: element.id,
        siteName: element.site.name,
        companies: [],
        createdBy: element.createdBy,
        startTime: new Date(element.startTime).toLocaleString(),
        endTime: '',
        workOrderId: '',
        workOrderDesciption: '',
        asset: '',
      };
      element.maintenances.forEach((main) => {
        sessionObj.companies.push(main.name);
      });
      if (element.workOrder === null) {
        sessionObj.workOrderId = 'n/a';
        sessionObj.workOrderDesciption = 'n/a';
        sessionObj.asset = 'n/a';
      } else {
        sessionObj.workOrderId = element.workOrder.id;
        sessionObj.workOrderDesciption = element.workOrder.description;
        sessionObj.asset = element.workOrder.asset.name;
      }
      if (element.endTime === null) {
        sessionObj.endTime = 'In Progress';
      } else {
        sessionObj.endTime = new Date(element.endTime).toLocaleString();
      }
      sessionsToExport.push(sessionObj);
    });

    const fileName = 'SiteSessionsReport-' + new Date(this.fromDate).toLocaleString() + 'to' + new Date(this.toDate).toLocaleString();
    // tslint:disable-next-line:no-unused-expression
    new ngxCsv(sessionsToExport, fileName, this.options);
  }
}
